'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NoResults from './Results/NoResults.react';
import Loading from'./Results/Loading.react';
import RecipeCard from './Results/RecipeCard.react';
import FoodCard from './Results/FoodCard.react';
import PlanCard from '../Dashboard/FeaturedPlans/PlanCard.react';
import ComboCard from './Results/ComboCard.react';
import BrandCard from './Results/BrandCard.react';
import CollectionCard from './Results/CollectionCard.react';
import CategoryCard from './Results/CategoryCard.react';
import PageCard from './Results/PageCard.react';

import BoardStore from '../../stores/BoardStore';

import { fetchDocumentsById } from '../../utils/Content';

import './Results.scss';

export default class Results extends Component {
    static propTypes = {
        loading: PropTypes.bool,
        results: PropTypes.array,
        noResultsCopy: PropTypes.node,
        overrideCreateCustomButtonCopy:  PropTypes.node,
    };

    static defaultProps = {
        loading: false,
        results: [],
    };

    static contextTypes = {
        user: PropTypes.object,
        addSwapContext: PropTypes.object,
        collection_editor_recipes: PropTypes.array,
        breakpoint47em: PropTypes.bool,
        isPro: PropTypes.bool,

        onSelectRecipe: PropTypes.func,
        onSelectCombo: PropTypes.func,
        onSelectProduct: PropTypes.func,
        onSelectFood: PropTypes.func,
        onSelectBrand: PropTypes.func,
        onSelectCollection: PropTypes.func,
        onSelectPage: PropTypes.func,
    };

    constructor(props) {
        super(props);

        const results = (props.results || []);

        this.state = {
            boards: BoardStore.getBoards(),

            results,

            workingButtonIndex: null,
        };
    }

    componentDidMount = () => {
        BoardStore.addChangeListener(this.onBoardStoreChange);
    }

    componentWillUnmount = () => {
        BoardStore.removeChangeListener(this.onBoardStoreChange);
    }

    onBoardStoreChange = () => {
        this.setState({boards: BoardStore.getBoards()});
    }

    renderResult = (result, key) => {
        const { user, onSelectRecipe, onSelectCombo, onSelectFood, onSelectBrand, onSelectCollection, onSelectPage,
                breakpoint47em, addSwapContext, collection_editor_recipes } = this.context;
        const { params: { sort_by, sort_order } } = this.props;
        const { workingButtonIndex } = this.state;

        const proxyOnSelectCombo = async (combo) => {
            const comboRecipes = [combo.main_dish, combo.side_dish];

            this.setState({workingButtonIndex: key});

            const documents = await fetchDocumentsById(comboRecipes)
            let mainDish, sideDish;

            documents.forEach(doc => {
                if (combo.main_dish === doc.uuid) {
                    mainDish = doc;
                }

                if (combo.side_dish === doc.uuid) {
                    sideDish = doc;
                }
            });

            onSelectCombo(combo, mainDish, sideDish, addSwapContext.participants, undefined, undefined, {
                organicRanking: result.organic_ranking,
                searchRanking: key + 1,
                resultType: result.result_type,
                term: this.props.searchTerm,
                sortBy: sort_by,
                sortOrder: sort_order,
            });

            this.setState({workingButtonIndex: null});
        };

        const isLogging = (addSwapContext && addSwapContext.auto_log) ? true : false;

        const { capabilities = {} } = user || {};
        let alreadyInCollection = false;

        if(collection_editor_recipes && collection_editor_recipes.length){
            alreadyInCollection = collection_editor_recipes.includes(result.uuid);
        }

        return (
            <div className="result-container" key={result.uuid}>
                {result.type === 'recipe' ?
                    <RecipeCard recipe={result}
                        sortBy={sort_by}
                        sortOrder={sort_order}
                        organicRanking={result.organic_ranking}
                        searchRanking={key+1}
                        searchTerm={this.props.searchTerm}
                        isLogging={isLogging}
                        shortMode={!breakpoint47em}
                        alreadyInCollection={alreadyInCollection}/>
                : null}

                {result.type === 'plan'   ?
                    <PlanCard plan={result}
                        showFavorites={result.links && result.links.self ? true : false}
                        showAdvancedMode={true}
                        shortMode={!breakpoint47em}
                        isSearchResult={true} />
                : null}

                {result.type === 'combo' ?
                    <ComboCard combo={result} sortBy={sort_by} sortOrder={sort_order}
                        organicRanking={result.organic_ranking}
                        searchRanking={key+1}
                        searchTerm={this.props.searchTerm}
                        isLogging={isLogging}
                        shortMode={!breakpoint47em} />
                : null}

                {result.type === 'food' ?
                    <FoodCard food={result}
                        sortBy={sort_by}
                        sortOrder={sort_order}
                        organicRanking={result.organic_ranking}
                        searchRanking={key+1}
                        searchTerm={this.props.searchTerm}
                        isLogging={isLogging}
                        shortMode={!breakpoint47em} />
                : null}

                {result.type === 'brand' ?
                    <BrandCard brand={result} isLogging={isLogging} />
                : null}

                {result.type === 'collection' ?
                    <CollectionCard collection={result} isLogging={isLogging} />
                : null}

                {result.type === 'category' ?
                    <CategoryCard category={result} />
                : null}

                {result.type === 'page' ?
                    <PageCard page={result} />
                : null}

                {result.type === 'recipe' && onSelectRecipe ?
                    <footer>
                        {!alreadyInCollection
                            ? <button onClick={() => onSelectRecipe(result, addSwapContext.participants, undefined, {organicRanking: result.organic_ranking, sortBy: sort_by, sortOrder: sort_order, searchRanking: key+1, term: this.props.searchTerm})}>
                                select
                                {(result.protection !== 'public' && !capabilities.meal_planner) ? <i className="icon-lock" /> : null}
                              </button>
                            : <span className="already-in-collection"><i className="icon-check"/><p>Already in Collection</p></span>
                        }
                    </footer>
                : null}

                {result.type === 'collection' && onSelectCollection ?
                    <footer>
                        <button onClick={() => onSelectCollection(result)}>select</button>
                    </footer>
                : null}

                {result.type === 'combo' && onSelectCombo ?
                    <footer>
                        <button onClick={() => proxyOnSelectCombo(result)} disabled={workingButtonIndex == key}>
                            {workingButtonIndex === key
                                ? <i className="icon-spinner2" />
                                : 'select'}
                            {(result.protection !== 'public' && !capabilities.meal_planner) ? <i className="icon-lock" /> : null}
                        </button>
                    </footer>
                : null}

                {result.type === 'food' && onSelectFood ?
                    <footer>
                        <button onClick={() => onSelectFood(result, undefined, undefined, undefined, undefined, undefined, {organicRanking: result.organic_ranking, sortBy: sort_by, sortOrder: sort_order, searchRanking: key+1, term: this.props.searchTerm})}>
                            select
                            {!capabilities.meal_planner ? <i className="icon-lock" /> : null}
                        </button>
                    </footer>
                : null}

                {result.type === 'brand' && onSelectBrand ?
                    <footer>
                        <button onClick={() => onSelectBrand(result)}>select</button>
                    </footer>
                : null}

                {result.type === 'page' && onSelectPage ?
                    <footer>
                        <button onClick={() => onSelectPage(result)}>select</button>
                    </footer>
                : null}
            </div>
        );
    }

    render() {
        const { params, loaded, loading, results, noResultsCopy, loadingMessage, hideCreateCustom, overrideCreateCustomButtonCopy } = this.props;
        const { isPro } = this.context;

        return (
            <div className="global-search-results">
                {loaded && !loading && !(results && results.length) ?
                    <NoResults overrideCreateCustomButtonCopy={overrideCreateCustomButtonCopy} hideCreateCustom={hideCreateCustom} noResultsCopy={noResultsCopy} params={params} />
                : null}

                {isPro && params?.types?.length == 1 && params.types[0] == "collection" ?
                    <div className="result-container">
                        <div className="false-collection-result">
                            <svg width="36" height="31" viewBox="0 0 36 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.5934 0.885391C17.3752 0.959608 17.1735 1.09425 17.0166 1.30027L6.82124 14.3283L0.756247 16.3913C0.430809 16.502 0.255112 16.8588 0.365809 17.1842L3.98863 27.8349C4.09933 28.1604 4.45617 28.3361 4.78161 28.2254L10.8466 26.1624L26.8712 30.2717C27.1199 30.3356 27.3669 30.3218 27.5813 30.2488C28.1989 30.0387 28.6012 29.3532 28.3647 28.6579L19.1843 1.66871C18.9478 0.973452 18.211 0.675316 17.5934 0.885391ZM24.7724 26.8307L11.5451 23.4368L10.7323 23.2305L5.94687 24.8583L3.73293 18.3495L8.51835 16.7217L9.03314 16.0639L17.4513 5.30736L24.7724 26.8307ZM33.5286 10.3601L28.7949 11.9702C28.4695 12.0809 28.2938 12.4378 28.4045 12.7632L28.9077 14.2425C29.0184 14.5679 29.3752 14.7436 29.7006 14.6329L34.4343 13.0228C34.7597 12.9121 34.9354 12.5552 34.8247 12.2298L34.3215 10.7505C34.2109 10.4251 33.854 10.2494 33.5286 10.3601ZM35.2723 20.569L30.3919 19.6007C30.3118 19.5851 30.2295 19.5855 30.1496 19.6017C30.0696 19.618 29.9937 19.6498 29.926 19.6954C29.8584 19.7411 29.8004 19.7995 29.7554 19.8676C29.7104 19.9356 29.6792 20.0118 29.6636 20.0919L29.3617 21.6181C29.2946 21.9545 29.514 22.2842 29.8504 22.3513L34.7308 23.3195C34.8109 23.3351 34.8932 23.3348 34.9731 23.3185C35.0531 23.3023 35.129 23.2704 35.1967 23.2248C35.2643 23.1792 35.3223 23.1207 35.3673 23.0527C35.4123 22.9847 35.4435 22.9085 35.4591 22.8284L35.761 21.3022C35.8281 20.9658 35.605 20.6373 35.2723 20.569ZM25.4333 7.66731C25.4945 7.72128 25.5657 7.76268 25.6428 7.78914C25.72 7.8156 25.8016 7.8266 25.883 7.82151C25.9644 7.81643 26.044 7.79535 26.1173 7.75949C26.1906 7.72364 26.2561 7.6737 26.31 7.61253L29.5878 3.86931C29.8135 3.61099 29.7864 3.21586 29.5281 2.99015L28.3631 1.96705C28.3019 1.91307 28.2308 1.87167 28.1536 1.84521C28.0764 1.81876 27.9948 1.80776 27.9134 1.81284C27.832 1.81793 27.7524 1.839 27.6791 1.87486C27.6058 1.91072 27.5404 1.96066 27.4864 2.02183L24.2086 5.76505C24.1003 5.88972 24.0458 6.05221 24.057 6.21696C24.0682 6.38171 24.1442 6.53532 24.2683 6.64421L25.4333 7.66731Z" fill="#A30063"/>
                            </svg>
                            <p>Have a collection of favorite recipes? <a target="_blank" href="https://forms.gle/Y3XHbL6Xs5my96HH7">Submit an order for a branded pdf recipe booklet.</a> Shareable with patients outside of EatLove.</p>
                        </div>
                    </div>
                : null}

                {!loading && results.map(this.renderResult)}



                {loading ?
                    <Loading loadingMessage={loadingMessage} />
                : null}
            </div>
        );
    }
}
